import { ElementRef } from '@angular/core';

export function applyRteSettings(
  data: any,
  rteEl: ElementRef<HTMLElement>
): void {
  const rteStyleSettingsComposition = (data && data.rteStyleSettingsComposition) || {};
  const {
    textFontWeight,
    textSize,
    textColor,
  } = rteStyleSettingsComposition;

  const fontWeight = textFontWeight && textFontWeight.value;
  const fontSize = textSize && textSize.value;
  const color = textColor && textColor.value;

  if (rteEl && rteEl.nativeElement) {
    if (fontWeight) {
      rteEl.nativeElement.style.setProperty('--rte-font-weight', fontWeight);
    }
    if (fontSize) {
      rteEl.nativeElement.style.setProperty('--rte-font-size', fontSize + 'px');
    }
    if (color) {
      rteEl.nativeElement.style.setProperty('--rte-font-color', color);
    }
  }
}
